import { gql } from '@apollo/client';

import { ESlice } from './types';

export interface IVisitorsReportRequest {
  input: {
    from: string;
    to: string;
    slice: ESlice;
  };
}
export interface IVisitorsReportResponse {
  uniqueUsersReport: {
    labels: Array<string>;
    keys: Array<string>;
    points: number;
    data: Array<{ values: Array<number> }>;
    summary: Array<{ title: string; value: number }>;
  };
}
export const GENERATE_VISITORS_REPORT = gql`
  query uniqueUsersReport($input: UniqueUsersReport!) {
    uniqueUsersReport(input: $input) {
      labels
      keys
      points
      data {
        values
      }
      summary {
        title
        value
      }
    }
  }
`;

export interface IVisitorsReportFileResponse {
  uniqueUsersReport: {
    url: string;
  };
}
export const GENERATE_VISITORS_REPORT_FILE = gql`
  query uniqueUsersReportFile($input: UniqueUsersReport!) {
    uniqueUsersReport(input: $input) {
      url
    }
  }
`;
